module.exports = __webpack_public_path__ + "img/animation-current-circle.ef19af56.svg";